<template>
  <UiBaseIcon
    width="20"
    height="20"
    viewBox="0 0 20 20"
    class="icon"
  >
    <path
      d="M19 7.58781C19 7.32356 18.7981 7.15934 18.3941 7.09499L12.964 6.31316L10.5301 1.43913C10.3932 1.14633 10.2164 1 10.0001 1C9.78379 1 9.60707 1.14633 9.47003 1.43913L7.03606 6.31316L1.60569 7.09499C1.20195 7.15934 1 7.32356 1 7.58781C1 7.73785 1.09018 7.90924 1.27049 8.10206L5.20804 11.8941L4.27776 17.25C4.26332 17.35 4.25616 17.4216 4.25616 17.4643C4.25616 17.6143 4.29397 17.741 4.36967 17.8446C4.44534 17.9484 4.55885 18 4.71037 18C4.84025 18 4.98442 17.9573 5.14306 17.8716L9.99994 15.3433L14.8571 17.8713C15.0086 17.9571 15.1528 18 15.2896 18C15.5856 18 15.7334 17.8218 15.7334 17.4646C15.7334 17.3718 15.7298 17.3004 15.7225 17.2501L14.7923 11.8944L18.7189 8.10232C18.9064 7.91637 19 7.74491 19 7.58781Z"
    />
  </UiBaseIcon>
</template>

<script setup lang="ts">
  import { UiBaseIcon } from '@experience/core-base-icon-ui';
</script>
